const fonts = {
  primary:
    "'-apple-system','BlinkMacSystemFont','Helvetica Neue','Segoe UI','Hiragino Kaku Gothic ProN','Hiragino Sans','ヒラギノ角ゴ ProN W3','Arial','メイリオ','Meiryo',sans-serif",
  gothic:
    "'YuGothic','Yu Gothic','Avenir','Helvetica Neue','Helvetica','Arial','Hiragino Sans','ヒラギノ角ゴシック','メイリオ',Meiryo,'ＭＳ Ｐゴシック','MS PGothic',sans-serif",
  serif: "'Merriweather', Georgia, Serif",
  sansSerif:
    "'SF Pro Display', '-apple-system', 'BlinkMacSystemFont', 'San Francisco', 'Helvetica Neue', 'Helvetica', 'Ubuntu', 'Roboto', 'Noto', 'Segoe UI', 'Arial', sans-serif",
  monospace: `"Operator Mono", Consolas, Menlo, Monaco, source-code-pro, Courier New, monospace`,
  jost: "Jost, sans-serif",
  sacra: `"Sacramento", cursive`,
}

export default fonts
